// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const rtn: CountryValidator<"US"> = createValidator(
  "us.rtn",
  170,
);

export default rtn;
export const compact = rtn.compact;
export const format = rtn.format;
export const validate = rtn.validate;
export const generate = (): string =>
  rtn.generate?.() ??
  (() => {
    throw new Error(
      "Validator us.rtn cannot generate values",
    );
  })();
